import { createAction } from '@reduxjs/toolkit';

import type { UpdateContentFilterSettingsPayload } from '@polyai/stream/commands/handlers/content-filter-settings/update-content-filter-settings/schema';

import { CONTENT_FILTER_SETTINGS_SLICE_NAME } from './constants';

export const updateContentFilterSettings =
  createAction<UpdateContentFilterSettingsPayload>(
    `${CONTENT_FILTER_SETTINGS_SLICE_NAME}/updateContentFilterSettings`,
  );
